var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "sidebar",
      staticClass: "app-sidebar",
      class: {
        "app-sidebar_collapsed": _vm.collapsed,
      },
    },
    [
      _c("div", {
        staticClass: "app-sidebar__overlay",
        class: {
          "app-sidebar__overlay_hidden": !_vm.activeMenuItem,
        },
        on: {
          click: function ($event) {
            _vm.activeMenuItem = null
          },
        },
      }),
      _c(
        "div",
        {
          staticClass: "app-sidebar__wrapper",
          class: { "app-sidebar__wrapper_collapsed": _vm.collapsed },
        },
        [
          _c("div", { staticClass: "app-sidebar__header" }, [
            _c(
              "div",
              {
                staticClass: "app-sidebar__user",
                class: {
                  "app-sidebar__user_active": _vm.activeMenuItem === "user",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "user") },
              },
              [
                _vm.user.avatar
                  ? _c("div", {
                      staticClass: "app-sidebar__user-avatar",
                      style: { backgroundImage: `url(${_vm.user.avatar})` },
                    })
                  : _vm._e(),
                !_vm.user.avatar
                  ? _c(
                      "div",
                      { staticClass: "app-sidebar__user-avatar-placeholder" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "34",
                              height: "34",
                              viewBox: "0 0 34 34",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "17",
                                cy: "17",
                                r: "17",
                                fill: "#8E9CBB",
                              },
                            }),
                            _c(
                              "mask",
                              {
                                attrs: {
                                  id: "mask0",
                                  "mask-type": "alpha",
                                  maskUnits: "userSpaceOnUse",
                                  x: "0",
                                  y: "0",
                                  width: "34",
                                  height: "34",
                                },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "17",
                                    cy: "17",
                                    r: "17",
                                    fill: "#8E9CBB",
                                  },
                                }),
                              ]
                            ),
                            _c("g", { attrs: { mask: "url(#mask0)" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M28 30L26 31.5V26.5926C26 25.905 25.7103 25.2456 25.1945 24.7594C24.6788 24.2731 23.9793 24 23.25 24H17H10.75C10.0207 24 9.32118 24.2731 8.80546 24.7594C8.28973 25.2456 8 25.905 8 26.5926V31.5L6 30V26.6667C6 25.429 6.50044 24.242 7.39124 23.3668C8.28204 22.4917 9.49022 22 10.75 22C10.75 22 15 22 17 22C19 22 23.25 22 23.25 22C24.5098 22 25.718 22.4917 26.6088 23.3668C27.4996 24.242 28 25.429 28 26.6667V30Z",
                                  fill: "#333333",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M23 14C23 17.3137 20.3137 20 17 20C13.6863 20 11 17.3137 11 14C11 10.6863 13.6863 8 17 8C20.3137 8 23 10.6863 23 14ZM21 14C21 16.2091 19.2091 18 17 18C14.7909 18 13 16.2091 13 14C13 11.7909 14.7909 10 17 10C19.2091 10 21 11.7909 21 14Z",
                                  fill: "#333333",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "app-sidebar__user-name" }, [
                  _vm._v(" " + _vm._s(_vm.user.name) + " "),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "app-sidebar__notifications",
                class: {
                  "app-sidebar__notifications__active":
                    _vm.activeMenuItem === "notifications",
                },
                style: {
                  cursor:
                    _vm.notifications.list.length === 0 ? "initial" : "pointer",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "notifications") },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "21",
                      viewBox: "0 0 18 21",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M14.3333 7.88475C14.3333 6.2975 13.7714 4.77525 12.7712 3.6529C11.771 2.53054 10.4145 1.90001 9 1.90001C7.58551 1.90001 6.22896 2.53054 5.22876 3.6529C4.22857 4.77525 3.66667 6.2975 3.66667 7.88475C3.66667 14.8669 1 15.8999 1 15.8999H17C17 15.8999 14.3333 14.8669 14.3333 7.88475Z",
                        stroke: "#8E9CBB",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M11 19C10.7968 19.3031 10.505 19.5547 10.154 19.7295C9.80302 19.9044 9.40506 19.9965 9 19.9965C8.59494 19.9965 8.19698 19.9044 7.84598 19.7295C7.49498 19.5547 7.20325 19.3031 7 19",
                        stroke: "#8E9CBB",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
                _vm.notifications.count > 0
                  ? _c(
                      "div",
                      { staticClass: "app-sidebar__notifications-count" },
                      [_vm._v(" " + _vm._s(_vm.notifications.count) + " ")]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _c("div", { staticClass: "app-sidebar__menu" }, [
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__menu-item app-sidebar__menu-item_calculations",
                class: {
                  "app-sidebar__menu-item_active":
                    _vm.activeMenuItem === "calculations",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "calculations") },
              },
              [
                _c("div", { staticClass: "app-sidebar__menu-item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "20",
                        viewBox: "0 0 18 20",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 7H17M4 11H6M4 15H6M8 11H10M8 15H10M13 16V10M3 19H15C16.1046 19 17 18.1046 17 17V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19Z",
                          "stroke-width": "2",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "app-sidebar__menu-item-label" }, [
                  _vm._v("Расчеты"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__menu-item app-sidebar__menu-item_employees",
                class: {
                  "app-sidebar__menu-item_active":
                    _vm.activeMenuItem === "employees",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "employees") },
              },
              [
                _c("div", { staticClass: "app-sidebar__menu-item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "22",
                        viewBox: "0 0 18 22",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M13 20C13 20.5523 13.4477 21 14 21C14.5523 21 15 20.5523 15 20H13ZM11.5 16V15V16ZM6.5 16V15V16ZM4 18.6667H3H4ZM3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20H3ZM8 5C8 5.55228 8.44772 6 9 6C9.55229 6 10 5.55228 10 5H8ZM10 1C10 0.447715 9.55229 0 9 0C8.44772 0 8 0.447715 8 1H10ZM15 20V18.6667H13V20H15ZM15 18.6667C15 17.7143 14.6459 16.789 13.9973 16.0971L12.5382 17.465C12.8273 17.7733 13 18.2046 13 18.6667H15ZM13.9973 16.0971C13.3466 15.4031 12.4498 15 11.5 15V17C11.8762 17 12.2512 17.1588 12.5382 17.465L13.9973 16.0971ZM11.5 15H6.5V17H11.5V15ZM6.5 15C5.55015 15 4.65335 15.4031 4.0027 16.0971L5.46177 17.465C5.74879 17.1588 6.12376 17 6.5 17V15ZM4.0027 16.0971C3.35409 16.789 3 17.7143 3 18.6667H5C5 18.2046 5.1727 17.7733 5.46177 17.465L4.0027 16.0971ZM3 18.6667V20H5V18.6667H3ZM10 11C10 11.5523 9.55228 12 9 12V14C10.6569 14 12 12.6569 12 11H10ZM9 12C8.44772 12 8 11.5523 8 11H6C6 12.6569 7.34315 14 9 14V12ZM8 11C8 10.4477 8.44772 10 9 10V8C7.34315 8 6 9.34315 6 11H8ZM9 10C9.55229 10 10 10.4477 10 11H12C12 9.34315 10.6569 8 9 8V10ZM2 18V6H0V18H2ZM4 4H14V2H4V4ZM16 6V18H18V6H16ZM14 20H4V22H14V20ZM16 18C16 19.1046 15.1046 20 14 20V22C16.2091 22 18 20.2091 18 18H16ZM14 4C15.1046 4 16 4.89543 16 6H18C18 3.79086 16.2091 2 14 2V4ZM2 6C2 4.89543 2.89543 4 4 4V2C1.79086 2 0 3.79086 0 6H2ZM0 18C0 20.2091 1.79086 22 4 22V20C2.89543 20 2 19.1046 2 18H0ZM10 5V1H8V5H10Z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "app-sidebar__menu-item-label" }, [
                  _vm._v("Кадры"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__menu-item app-sidebar__menu-item_reports",
                class: {
                  "app-sidebar__menu-item_active":
                    _vm.activeMenuItem === "reports",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "reports") },
              },
              [
                _c("div", { staticClass: "app-sidebar__menu-item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "16",
                        viewBox: "0 0 20 16",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1H2ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14V16ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM6 9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9H6ZM8 11C8 11.5523 8.44772 12 9 12C9.55229 12 10 11.5523 10 11H8ZM10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5H10ZM16 11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11H16ZM18 3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3H18ZM12 11C12 11.5523 12.4477 12 13 12C13.5523 12 14 11.5523 14 11H12ZM14 7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7H14ZM0 1V15H2V1H0ZM1 16H19V14H1V16ZM6 11V9H4V11H6ZM10 11V5H8V11H10ZM18 11V3H16V11H18ZM14 11V7H12V11H14Z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "app-sidebar__menu-item-label" }, [
                  _vm._v("Отчеты"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__menu-item app-sidebar__menu-item_reference",
                class: {
                  "app-sidebar__menu-item_active":
                    _vm.activeMenuItem === "references",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "references") },
              },
              [
                _c("div", { staticClass: "app-sidebar__menu-item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "19",
                        height: "20",
                        viewBox: "0 0 19 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 17V3C1 1.89543 1.89543 1 3 1H16V19H3C1.89543 19 1 18.1046 1 17ZM1 17C1 15.8954 1.89543 15 3 15H16M4 6H13M16 4H19M16 8H19M16 12H19M5 9H12",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "app-sidebar__menu-item-label" }, [
                  _vm._v("Справочники"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__menu-item app-sidebar__menu-item_all_sections",
                class: {
                  "app-sidebar__menu-item_active":
                    _vm.activeMenuItem === "allSections",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "allSections") },
              },
              [
                _c("div", { staticClass: "app-sidebar__menu-item-icon" }, [
                  _c(
                    "svg",
                    {
                      staticStyle: { "enable-background": "new 0 0 512 512" },
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        x: "0px",
                        y: "0px",
                        viewBox: "0 0 512 512",
                        "xml:space": "preserve",
                        width: "20px",
                        height: "22px",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M492,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,236,492,236z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M492,76H20C8.954,76,0,84.954,0,96s8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,76,492,76z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M492,396H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20\nC512,404.954,503.046,396,492,396z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "app-sidebar__menu-item-label" }, [
                  _vm._v("Все разделы"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__menu-item app-sidebar__menu-item_mobile-menu",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "app-sidebar__menu-item-icon",
                    class: {
                      "app-sidebar__menu-item-icon_active":
                        !_vm.mobileMenuActive,
                    },
                    on: { click: (e) => _vm.openMobileMenu(e) },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "16",
                          viewBox: "0 0 18 16",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1 1H17M1 8H17M1 15H17",
                            stroke: "#8E9CBB",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "app-sidebar__menu-item-icon",
                    class: {
                      "app-sidebar__menu-item-icon_active":
                        _vm.mobileMenuActive,
                    },
                    on: {
                      click: function ($event) {
                        _vm.mobileMenuActive = false
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "16",
                          viewBox: "0 0 18 16",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M16.0254 15.0007L2.02468 1M1.9541 15.0007L15.9548 1",
                            stroke: "#FF238D",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "app-sidebar__settings" }, [
            _c(
              "a",
              {
                staticClass:
                  "app-sidebar__settings-item app-sidebar__settings-item_settings",
                attrs: {
                  href: _vm.getMenuItemHref({ routeName: "tables-settings" }),
                },
                on: {
                  click: function ($event) {
                    return _vm.onSidebarMenuLinkClick($event, {
                      routeName: "tables-settings",
                    })
                  },
                },
              },
              [
                _c("div", { staticClass: "app-sidebar__settings-item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "22",
                        height: "22",
                        viewBox: "0 0 22 22",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M11 13.7273C12.5062 13.7273 13.7273 12.5062 13.7273 11C13.7273 9.49377 12.5062 8.27273 11 8.27273C9.49377 8.27273 8.27273 9.49377 8.27273 11C8.27273 12.5062 9.49377 13.7273 11 13.7273Z",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M17.7273 13.7273C17.6063 14.0015 17.5702 14.3056 17.6236 14.6005C17.6771 14.8954 17.8177 15.1676 18.0273 15.3818L18.0818 15.4364C18.2509 15.6052 18.385 15.8057 18.4765 16.0265C18.568 16.2472 18.6151 16.4838 18.6151 16.7227C18.6151 16.9617 18.568 17.1983 18.4765 17.419C18.385 17.6397 18.2509 17.8402 18.0818 18.0091C17.913 18.1781 17.7124 18.3122 17.4917 18.4037C17.271 18.4952 17.0344 18.5423 16.7955 18.5423C16.5565 18.5423 16.3199 18.4952 16.0992 18.4037C15.8785 18.3122 15.678 18.1781 15.5091 18.0091L15.4545 17.9545C15.2403 17.745 14.9682 17.6044 14.6733 17.5509C14.3784 17.4974 14.0742 17.5335 13.8 17.6545C13.5311 17.7698 13.3018 17.9611 13.1403 18.205C12.9788 18.4489 12.8921 18.7347 12.8909 19.0273V19.1818C12.8909 19.664 12.6994 20.1265 12.3584 20.4675C12.0174 20.8084 11.5549 21 11.0727 21C10.5905 21 10.1281 20.8084 9.78708 20.4675C9.4461 20.1265 9.25455 19.664 9.25455 19.1818V19.1C9.24751 18.7991 9.15011 18.5073 8.97501 18.2625C8.79991 18.0176 8.55521 17.8312 8.27273 17.7273C7.99853 17.6063 7.69437 17.5702 7.39947 17.6236C7.10456 17.6771 6.83244 17.8177 6.61818 18.0273L6.56364 18.0818C6.39478 18.2509 6.19425 18.385 5.97353 18.4765C5.7528 18.568 5.51621 18.6151 5.27727 18.6151C5.03834 18.6151 4.80174 18.568 4.58102 18.4765C4.36029 18.385 4.15977 18.2509 3.99091 18.0818C3.82186 17.913 3.68775 17.7124 3.59626 17.4917C3.50476 17.271 3.45766 17.0344 3.45766 16.7955C3.45766 16.5565 3.50476 16.3199 3.59626 16.0992C3.68775 15.8785 3.82186 15.678 3.99091 15.5091L4.04545 15.4545C4.25503 15.2403 4.39562 14.9682 4.4491 14.6733C4.50257 14.3784 4.46647 14.0742 4.34545 13.8C4.23022 13.5311 4.03887 13.3018 3.79497 13.1403C3.55107 12.9788 3.26526 12.8921 2.97273 12.8909H2.81818C2.33597 12.8909 1.87351 12.6994 1.53253 12.3584C1.19156 12.0174 1 11.5549 1 11.0727C1 10.5905 1.19156 10.1281 1.53253 9.78708C1.87351 9.4461 2.33597 9.25455 2.81818 9.25455H2.9C3.2009 9.24751 3.49273 9.15011 3.73754 8.97501C3.98236 8.79991 4.16883 8.55521 4.27273 8.27273C4.39374 7.99853 4.42984 7.69437 4.37637 7.39947C4.3229 7.10456 4.18231 6.83244 3.97273 6.61818L3.91818 6.56364C3.74913 6.39478 3.61503 6.19425 3.52353 5.97353C3.43203 5.7528 3.38493 5.51621 3.38493 5.27727C3.38493 5.03834 3.43203 4.80174 3.52353 4.58102C3.61503 4.36029 3.74913 4.15977 3.91818 3.99091C4.08704 3.82186 4.28757 3.68775 4.50829 3.59626C4.72901 3.50476 4.96561 3.45766 5.20455 3.45766C5.44348 3.45766 5.68008 3.50476 5.9008 3.59626C6.12152 3.68775 6.32205 3.82186 6.49091 3.99091L6.54545 4.04545C6.75971 4.25503 7.03183 4.39562 7.32674 4.4491C7.62164 4.50257 7.9258 4.46647 8.2 4.34545H8.27273C8.54161 4.23022 8.77093 4.03887 8.93245 3.79497C9.09397 3.55107 9.18065 3.26526 9.18182 2.97273V2.81818C9.18182 2.33597 9.37338 1.87351 9.71435 1.53253C10.0553 1.19156 10.5178 1 11 1C11.4822 1 11.9447 1.19156 12.2856 1.53253C12.6266 1.87351 12.8182 2.33597 12.8182 2.81818V2.9C12.8193 3.19253 12.906 3.47834 13.0676 3.72224C13.2291 3.96614 13.4584 4.15749 13.7273 4.27273C14.0015 4.39374 14.3056 4.42984 14.6005 4.37637C14.8954 4.3229 15.1676 4.18231 15.3818 3.97273L15.4364 3.91818C15.6052 3.74913 15.8057 3.61503 16.0265 3.52353C16.2472 3.43203 16.4838 3.38493 16.7227 3.38493C16.9617 3.38493 17.1983 3.43203 17.419 3.52353C17.6397 3.61503 17.8402 3.74913 18.0091 3.91818C18.1781 4.08704 18.3122 4.28757 18.4037 4.50829C18.4952 4.72901 18.5423 4.96561 18.5423 5.20455C18.5423 5.44348 18.4952 5.68008 18.4037 5.9008C18.3122 6.12152 18.1781 6.32205 18.0091 6.49091L17.9545 6.54545C17.745 6.75971 17.6044 7.03183 17.5509 7.32674C17.4974 7.62164 17.5335 7.9258 17.6545 8.2V8.27273C17.7698 8.54161 17.9611 8.77093 18.205 8.93245C18.4489 9.09397 18.7347 9.18065 19.0273 9.18182H19.1818C19.664 9.18182 20.1265 9.37338 20.4675 9.71435C20.8084 10.0553 21 10.5178 21 11C21 11.4822 20.8084 11.9447 20.4675 12.2856C20.1265 12.6266 19.664 12.8182 19.1818 12.8182H19.1C18.8075 12.8193 18.5217 12.906 18.2778 13.0676C18.0339 13.2291 17.8425 13.4584 17.7273 13.7273Z",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "app-sidebar__settings-item app-sidebar__settings-item_help",
                class: {
                  "app-sidebar__settings-item_active":
                    _vm.activeMenuItem === "help",
                },
                on: { click: (e) => _vm.selectMenuItem(e, "help") },
              },
              [
                _c("div", { staticClass: "app-sidebar__settings-item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM13.446 7.968C13.1017 7.38474 12.6153 6.89826 12.032 6.554L15.657 2.929L17.071 4.343L13.446 7.968ZM7.968 13.446L4.343 17.071L2.929 15.657L6.554 12.032C6.89826 12.6153 7.38474 13.1017 7.968 13.446ZM7.968 6.554C7.38474 6.89826 6.89826 7.38474 6.554 7.968L2.929 4.343L4.343 2.93L7.968 6.555V6.554ZM12.704 12.948C11.9332 13.655 10.9162 14.032 9.87079 13.9981C8.82541 13.9643 7.83488 13.5223 7.11142 12.767C6.38797 12.0116 5.98916 11.0029 6.00044 9.95706C6.01172 8.9112 6.4322 7.91136 7.17178 7.17178C7.91136 6.4322 8.9112 6.01172 9.95706 6.00044C11.0029 5.98916 12.0116 6.38797 12.767 7.11142C13.5223 7.83488 13.9643 8.82541 13.9981 9.87079C14.032 10.9162 13.655 11.9332 12.948 12.704C13.141 12.494 13.307 12.269 13.446 12.032L16.32 14.906C15.9093 15.4343 15.4343 15.9093 14.906 16.32L12.032 13.446C12.269 13.306 12.494 13.141 12.704 12.948ZM10 12C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10C12 9.46957 11.7893 8.96086 11.4142 8.58579C11.0391 8.21071 10.5304 8 10 8C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10C8 10.5304 8.21071 11.0391 8.58579 11.4142C8.96086 11.7893 9.46957 12 10 12Z",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "app-sidebar__collapse",
                class: { "app-sidebar__collapse_collapsed": _vm.collapsed },
                on: { click: _vm.toggleCollapse },
              },
              [
                _c("div", { staticClass: "app-sidebar__collapse-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "7",
                        height: "12",
                        viewBox: "0 0 7 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                          fill: "#8E9CBB",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._l(_vm.menuItemsLocal, function (section, sectionName) {
        return _c(
          "div",
          {
            key: sectionName,
            staticClass: "app-sidebar__submenu",
            class: {
              "app-sidebar__submenu_active":
                sectionName === _vm.activeMenuItem &&
                _vm.activeMenuItem !== "allSections",
              "app-sidebar__submenu_all_sections":
                sectionName === "allSections",
              "app-sidebar__submenu_all_sections_active":
                _vm.activeMenuItem === "allSections" &&
                sectionName === "allSections",
            },
          },
          [
            _c(
              "div",
              { staticClass: "app-sidebar__submenu-search" },
              [
                _c("c-input", {
                  attrs: {
                    placeholder: "Поиск",
                    icon: "search",
                    "placeholder-style": "italic",
                    clearable: "",
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
              ],
              1
            ),
            _vm.activeMenuItem !== "allSections"
              ? _c(
                  "div",
                  { staticClass: "app-sidebar__submenu-list" },
                  [
                    _vm._l(
                      _vm.menuItemsLocal[sectionName],
                      function (item, itemIndex) {
                        return [
                          _c(
                            "a",
                            {
                              key: `${itemIndex}-route`,
                              staticClass: "app-sidebar__submenu-list-item",
                              class: {
                                "app-sidebar__submenu-list-item_current":
                                  item.routeName &&
                                  item.routeName === _vm.$route.name,
                              },
                              attrs: {
                                href: _vm.getMenuItemHref(item),
                                target: _vm.isExternalMenuItem(item)
                                  ? "_blank"
                                  : null,
                                rel: _vm.isExternalMenuItem(item)
                                  ? "noopener noreferrer"
                                  : null,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSidebarMenuLinkClick(
                                    $event,
                                    item
                                  )
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          ),
                        ]
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm.activeMenuItem === "allSections"
              ? _c(
                  "div",
                  { staticClass: "app-sidebar__submenu-list-all-sections" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "app-sidebar__submenu-list-all-sections-column",
                      },
                      [
                        _vm.menuItemsLocal[sectionName]["Отчеты"] &&
                        _vm.menuItemsLocal[sectionName]["Отчеты"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("ОТЧЁТЫ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Отчеты"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-reports-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Кадры"] &&
                        _vm.menuItemsLocal[sectionName]["Кадры"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("КАДРЫ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Кадры"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-employee-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "app-sidebar__submenu-list-all-sections-column",
                      },
                      [
                        _vm.menuItemsLocal[sectionName]["Пользователи"] &&
                        _vm.menuItemsLocal[sectionName]["Пользователи"].length >
                          0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("ПОЛЬЗОВАТЕЛИ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName][
                                    "Пользователи"
                                  ],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-users-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Графики"] &&
                        _vm.menuItemsLocal[sectionName]["Графики"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("ГРАФИКИ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Графики"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-charts-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Листовки"] &&
                        _vm.menuItemsLocal[sectionName]["Листовки"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("ЛИСТОВКИ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Листовки"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-papers-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Маркетинг"] &&
                        _vm.menuItemsLocal[sectionName]["Маркетинг"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("МАРКЕТИНГ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Маркетинг"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-marketing-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Настройки"] &&
                        _vm.menuItemsLocal[sectionName]["Настройки"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("НАСТРОЙКИ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Настройки"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-settings-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Расчеты"] &&
                        _vm.menuItemsLocal[sectionName]["Расчеты"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("РАСЧЕТЫ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Расчеты"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-calculations-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.menuItemsLocal[sectionName]["Справочники"] &&
                        _vm.menuItemsLocal[sectionName]["Справочники"].length >
                          0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "app-sidebar__submenu-list-all-sections-column-item-title",
                                  },
                                  [_vm._v("СПРАВОЧНИКИ")]
                                ),
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName][
                                    "Справочники"
                                  ],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-reference-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "app-sidebar__submenu-list-all-sections-column",
                      },
                      [
                        _vm.menuItemsLocal[sectionName]["Остальные"] &&
                        _vm.menuItemsLocal[sectionName]["Остальные"].length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "app-sidebar__submenu-list-all-sections-column-item",
                              },
                              [
                                _vm._l(
                                  _vm.menuItemsLocal[sectionName]["Остальные"],
                                  function (item, itemIndex) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          key: `${itemIndex}-other-route`,
                                          staticClass:
                                            "app-sidebar__submenu-list-all-sections-column-item-title app-sidebar__submenu-list-all-sections-column-item-title-hover",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      _c(
        "div",
        {
          staticClass: "app-sidebar__submenu app-sidebar__submenu_user",
          class: {
            "app-sidebar__submenu_active": _vm.activeMenuItem === "user",
          },
        },
        [
          _c("div", { staticClass: "app-sidebar__submenu-logout" }, [
            _c("div", { staticClass: "app-sidebar__submenu-logout-icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "12",
                    viewBox: "0 0 14 12",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10 8.99121L13 5.99121L10 2.99121M12 5.99121H6M6 11H2.66667C2.22464 11 1.80072 10.8829 1.48816 10.6746C1.17559 10.4662 1 10.1836 1 9.88889V2.11111C1 1.81643 1.17559 1.53381 1.48816 1.32544C1.80072 1.11706 2.22464 1 2.66667 1H6",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]),
            _c(
              "a",
              {
                staticClass: "app-sidebar__submenu-logout-label",
                attrs: { href: "/index.php?r=site%2Flogout" },
              },
              [_vm._v("Выход")]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "app-sidebar__submenu app-sidebar__submenu_notifications",
          class: {
            "app-sidebar__submenu_active":
              _vm.activeMenuItem === "notifications",
          },
        },
        [
          _c(
            "div",
            { staticClass: "app-sidebar__submenu-notifications-list" },
            _vm._l(_vm.notifications.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "app-sidebar__submenu-notifications-list-item",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "app-sidebar__submenu-notifications-list-item-text",
                      domProps: { innerHTML: _vm._s(item.text) },
                    },
                    [_vm._v(" " + _vm._s(item.text) + " ")]
                  ),
                  item.files !== null
                    ? _c(
                        "viewer",
                        {
                          staticClass:
                            "app-sidebar__submenu-notifications-list-item-files",
                          attrs: { images: _vm.notifications.images },
                        },
                        _vm._l(item.files, function (file, ind) {
                          return _c(
                            "div",
                            {
                              key: ind,
                              staticClass:
                                "app-sidebar__submenu-notifications-list-item-files-file",
                            },
                            [
                              _vm.isImageExtension(file)
                                ? _c("img", {
                                    staticClass:
                                      "app-sidebar__submenu-notifications-list-item-files-file-image",
                                    attrs: { src: `images/${file}` },
                                  })
                                : _vm._e(),
                              _vm.getFileExtension(file) === "xls" ||
                              _vm.getFileExtension(file) === "xlsx"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-notifications-list-item-files-file-icon",
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M8.47538 3.125H10.5823L8.05679 6.85381L10.9062 11H8.71957L6.98437 8.43767L5.24813 11H3.0625L5.91196 6.85381L3.38642 3.125H5.49336L6.98437 5.29456L8.47538 3.125Z",
                                          fill: "#12C971",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M1 13V1H13V13H1Z",
                                          stroke: "#12C971",
                                          "stroke-width": "2",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.getFileExtension(file) === "doc" ||
                              _vm.getFileExtension(file) === "docx"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-notifications-list-item-files-file-icon",
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M10.8638 3.936L9.95481 10.2H7.54281L6.98481 5.70001L6.36381 10.2H4.00581L3.13281 3.936H4.98681L5.38281 8.859L6.04881 3.936H7.98381L8.54181 8.859L9.08181 3.936H10.8638Z",
                                          fill: "#2E6ECD",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M1 13V1H13V13H1Z",
                                          stroke: "#2E6ECD",
                                          "stroke-width": "2",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.getFileExtension(file) === "pdf"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-notifications-list-item-files-file-icon",
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1 13V1H13V13H1Z",
                                          stroke: "#E30000",
                                          "stroke-width": "2",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M7.97945 6.09586C7.48199 6.49417 7.46615 6.50383 7.17242 6.75471C6.87868 7.00559 6.76904 7.04139 6.26922 7.43694M7.97945 6.09586C9.67803 5.44281 10.1319 3.99982 8.95455 3.57597C7.77722 3.15211 7.14923 4.57193 7.97945 6.09586ZM7.97945 6.09586C8.08468 6.71115 8.08899 6.70618 8.15772 7.10943C8.22778 7.52049 8.22428 7.5653 8.33318 8.17999M6.26922 7.43694C6.87557 7.65332 7.31484 7.81337 7.31484 7.81337C7.31484 7.81337 7.72812 7.96025 8.33318 8.17999M6.26922 7.43694C4.83359 6.34459 3.31108 6.68697 3.51918 7.88235C3.72729 9.07774 5.31607 8.8924 6.26922 7.43694ZM8.33318 8.17999C10.1597 8.26208 11.0773 9.48294 10.1081 10.2545C9.13889 11.026 8.06455 9.8819 8.33318 8.17999Z",
                                          stroke: "#E30000",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isVideoExtension(file)
                                ? _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-notifications-list-item-files-file-icon",
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V2.33333C13 1.59695 12.403 1 11.6667 1Z",
                                          stroke: "#8E9CBB",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M10 7L5 4V10L10 7Z",
                                          stroke: "#8E9CBB",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.getFileExtension(file) === "mp3" ||
                              _vm.getFileExtension(file) === "mp4"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-notifications-list-item-files-file-icon",
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M8 8.5V4L10 5",
                                          stroke: "#8E9CBB",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M8 8.5C8 9.32843 7.32843 10 6.5 10C5.67157 10 5 9.32843 5 8.5C5 7.67157 5.67157 7 6.5 7C7.32843 7 8 7.67157 8 8.5Z",
                                          stroke: "#8E9CBB",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V2.33333C13 1.59695 12.403 1 11.6667 1Z",
                                          stroke: "#8E9CBB",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "app-sidebar__submenu-notifications-list-item-time",
                    },
                    [_vm._v(" " + _vm._s(item.created) + " ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "app-sidebar__mobilemenu",
          class: { "app-sidebar__mobilemenu_active": _vm.mobileMenuActive },
        },
        [
          _c(
            "div",
            {
              staticClass: "app-sidebar__mobilemenu-item",
              class: {
                "app-sidebar__mobilemenu-item_active":
                  _vm.activeMenuItem === "calculations",
              },
              on: { click: (e) => _vm.selectMenuItem(e, "calculations") },
            },
            [
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-label" }, [
                _vm._v("Расчеты"),
              ]),
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm.menuItemsLocal.calculations
            ? _c(
                "div",
                {
                  staticClass: "app-sidebar__mobilemenu-submenu",
                  class: {
                    "app-sidebar__mobilemenu-submenu_active":
                      _vm.activeMenuItem === "calculations",
                  },
                },
                _vm._l(
                  _vm.menuItemsLocal.calculations,
                  function (item, itemIndex) {
                    return _c(
                      "a",
                      {
                        key: itemIndex,
                        staticClass: "app-sidebar__mobilemenu-submenu-item",
                        class: {
                          "app-sidebar__mobilemenu-submenu-item_disabled":
                            !item.routeName && !item.route,
                          "app-sidebar__mobilemenu-submenu-item_current":
                            item.routeName &&
                            item.routeName === _vm.$route.name,
                        },
                        attrs: {
                          href: _vm.getMenuItemHref(item),
                          target: _vm.isExternalMenuItem(item)
                            ? "_blank"
                            : null,
                          rel: _vm.isExternalMenuItem(item)
                            ? "noopener noreferrer"
                            : null,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSidebarMenuLinkClick($event, item)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.label) + " ")]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "app-sidebar__mobilemenu-item",
              class: {
                "app-sidebar__mobilemenu-item_active":
                  _vm.activeMenuItem === "reports",
              },
              on: { click: (e) => _vm.selectMenuItem(e, "reports") },
            },
            [
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-label" }, [
                _vm._v("Отчеты"),
              ]),
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm.menuItemsLocal.reports
            ? _c(
                "div",
                {
                  staticClass: "app-sidebar__mobilemenu-submenu",
                  class: {
                    "app-sidebar__mobilemenu-submenu_active":
                      _vm.activeMenuItem === "reports",
                  },
                },
                _vm._l(_vm.menuItemsLocal.reports, function (item, itemIndex) {
                  return _c(
                    "a",
                    {
                      key: itemIndex,
                      staticClass: "app-sidebar__mobilemenu-submenu-item",
                      class: {
                        "app-sidebar__mobilemenu-submenu-item_disabled":
                          !item.routeName && !item.route,
                        "app-sidebar__mobilemenu-submenu-item_current":
                          item.routeName && item.routeName === _vm.$route.name,
                      },
                      attrs: {
                        href: _vm.getMenuItemHref(item),
                        target: _vm.isExternalMenuItem(item) ? "_blank" : null,
                        rel: _vm.isExternalMenuItem(item)
                          ? "noopener noreferrer"
                          : null,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSidebarMenuLinkClick($event, item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "app-sidebar__mobilemenu-item",
              class: {
                "app-sidebar__mobilemenu-item_active":
                  _vm.activeMenuItem === "employees",
              },
              on: { click: (e) => _vm.selectMenuItem(e, "employees") },
            },
            [
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-label" }, [
                _vm._v("Кадры"),
              ]),
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm.menuItemsLocal.employees
            ? _c(
                "div",
                {
                  staticClass: "app-sidebar__mobilemenu-submenu",
                  class: {
                    "app-sidebar__mobilemenu-submenu_active":
                      _vm.activeMenuItem === "employees",
                  },
                },
                _vm._l(
                  _vm.menuItemsLocal.employees,
                  function (item, itemIndex) {
                    return _c(
                      "a",
                      {
                        key: itemIndex,
                        staticClass: "app-sidebar__mobilemenu-submenu-item",
                        class: {
                          "app-sidebar__mobilemenu-submenu-item_disabled":
                            !item.routeName && !item.route,
                          "app-sidebar__mobilemenu-submenu-item_current":
                            item.routeName &&
                            item.routeName === _vm.$route.name,
                        },
                        attrs: {
                          href: _vm.getMenuItemHref(item),
                          target: _vm.isExternalMenuItem(item)
                            ? "_blank"
                            : null,
                          rel: _vm.isExternalMenuItem(item)
                            ? "noopener noreferrer"
                            : null,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSidebarMenuLinkClick($event, item)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.label) + " ")]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "app-sidebar__mobilemenu-item",
              class: {
                "app-sidebar__mobilemenu-item_active":
                  _vm.activeMenuItem === "references",
              },
              on: { click: (e) => _vm.selectMenuItem(e, "references") },
            },
            [
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-label" }, [
                _vm._v("Справочники"),
              ]),
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm.menuItemsLocal.references
            ? _c(
                "div",
                {
                  staticClass: "app-sidebar__mobilemenu-submenu",
                  class: {
                    "app-sidebar__mobilemenu-submenu_active":
                      _vm.activeMenuItem === "references",
                  },
                },
                _vm._l(
                  _vm.menuItemsLocal.references,
                  function (item, itemIndex) {
                    return _c(
                      "a",
                      {
                        key: itemIndex,
                        staticClass: "app-sidebar__mobilemenu-submenu-item",
                        class: {
                          "app-sidebar__mobilemenu-submenu-item_disabled":
                            !item.routeName && !item.route,
                          "app-sidebar__mobilemenu-submenu-item_current":
                            item.routeName &&
                            item.routeName === _vm.$route.name,
                        },
                        attrs: {
                          href: _vm.getMenuItemHref(item),
                          target: _vm.isExternalMenuItem(item)
                            ? "_blank"
                            : null,
                          rel: _vm.isExternalMenuItem(item)
                            ? "noopener noreferrer"
                            : null,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSidebarMenuLinkClick($event, item)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.label) + " ")]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "app-sidebar__mobilemenu-item",
              class: {
                "app-sidebar__mobilemenu-item_active":
                  _vm.activeMenuItem === "allSections",
              },
              on: { click: (e) => _vm.selectMenuItem(e, "allSections") },
            },
            [
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-label" }, [
                _vm._v("Все разделы"),
              ]),
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm.menuItemsLocal.allSections
            ? _c(
                "div",
                {
                  staticClass: "app-sidebar__mobilemenu-submenu",
                  class: {
                    "app-sidebar__mobilemenu-submenu_active":
                      _vm.activeMenuItem === "allSections",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "app-sidebar__submenu-list-all-sections" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "app-sidebar__submenu-list-all-sections-column",
                        },
                        [
                          _vm.menuItemsLocal["allSections"]["Отчеты"] &&
                          _vm.menuItemsLocal["allSections"]["Отчеты"].length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("ОТЧЁТЫ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"]["Отчеты"],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Кадры"] &&
                          _vm.menuItemsLocal["allSections"]["Кадры"].length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("КАДРЫ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"]["Кадры"],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "app-sidebar__submenu-list-all-sections-column",
                        },
                        [
                          _vm.userSectionNotEmpty
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("ПОЛЬЗОВАТЕЛИ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Пользователи"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Графики"] &&
                          _vm.menuItemsLocal["allSections"]["Графики"].length >
                            0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("ГРАФИКИ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Графики"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Листовки"] &&
                          _vm.menuItemsLocal["allSections"]["Листовки"].length >
                            0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("ЛИСТОВКИ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Листовки"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Маркетинг"] &&
                          _vm.menuItemsLocal["allSections"]["Маркетинг"]
                            .length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("МАРКЕТИНГ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Маркетинг"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Настройки"] &&
                          _vm.menuItemsLocal["allSections"]["Настройки"]
                            .length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("НАСТРОЙКИ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Настройки"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Расчеты"] &&
                          _vm.menuItemsLocal["allSections"]["Расчеты"].length >
                            0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("РАСЧЕТЫ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Расчеты"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.menuItemsLocal["allSections"]["Справочники"] &&
                          _vm.menuItemsLocal["allSections"]["Справочники"]
                            .length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-sidebar__submenu-list-all-sections-column-item-title",
                                    },
                                    [_vm._v("СПРАВОЧНИКИ")]
                                  ),
                                  _vm._l(
                                    _vm.menuItemsLocal["allSections"][
                                      "Справочники"
                                    ],
                                    function (item, itemIndex) {
                                      return _c(
                                        "a",
                                        {
                                          key: itemIndex,
                                          staticClass:
                                            "app-sidebar__submenu-list-item",
                                          class: {
                                            "app-sidebar__submenu-list-item_current":
                                              item.routeName &&
                                              item.routeName ===
                                                _vm.$route.name,
                                          },
                                          attrs: {
                                            href: _vm.getMenuItemHref(item),
                                            target: _vm.isExternalMenuItem(item)
                                              ? "_blank"
                                              : null,
                                            rel: _vm.isExternalMenuItem(item)
                                              ? "noopener noreferrer"
                                              : null,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSidebarMenuLinkClick(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-2 app-sidebar__submenu-list-all-sections-column",
                        },
                        [
                          _vm.menuItemsLocal["allSections"]["Остальные"] &&
                          _vm.menuItemsLocal["allSections"]["Остальные"]
                            .length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "app-sidebar__submenu-list-all-sections-column-item",
                                },
                                _vm._l(
                                  _vm.menuItemsLocal["allSections"][
                                    "Остальные"
                                  ],
                                  function (item, itemIndex) {
                                    return _c(
                                      "a",
                                      {
                                        key: itemIndex,
                                        staticClass:
                                          "app-sidebar__submenu-list-all-sections-column-item-title app-sidebar__submenu-list-all-sections-column-item-title-hover",
                                        class: {
                                          "app-sidebar__submenu-list-item_current":
                                            item.routeName &&
                                            item.routeName === _vm.$route.name,
                                        },
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          href: _vm.getMenuItemHref(item),
                                          target: _vm.isExternalMenuItem(item)
                                            ? "_blank"
                                            : null,
                                          rel: _vm.isExternalMenuItem(item)
                                            ? "noopener noreferrer"
                                            : null,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onSidebarMenuLinkClick(
                                              $event,
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item.label) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "app-sidebar__mobilemenu-item",
              class: {
                "app-sidebar__mobilemenu-item_active":
                  _vm.activeMenuItem === "bookmarks",
              },
              on: { click: (e) => _vm.selectMenuItem(e, "bookmarks") },
            },
            [
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-label" }, [
                _vm._v("Закладки"),
              ]),
              _c("div", { staticClass: "app-sidebar__mobilemenu-item-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z",
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm.menuItemsLocal.bookmarks
            ? _c(
                "div",
                {
                  staticClass: "app-sidebar__mobilemenu-submenu",
                  class: {
                    "app-sidebar__mobilemenu-submenu_active":
                      _vm.activeMenuItem === "bookmarks",
                  },
                },
                _vm._l(
                  _vm.menuItemsLocal.bookmarks,
                  function (item, itemIndex) {
                    return _c(
                      "div",
                      {
                        key: itemIndex,
                        staticClass: "app-sidebar__mobilemenu-submenu-item",
                        class: {
                          "app-sidebar__mobilemenu-submenu-item_disabled":
                            !item.route,
                          "app-sidebar__mobilemenu-submenu-item_current":
                            item.route === _vm.$route.name,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goTo(item)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.label) + " ")]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }